import { parseErrorMessage } from "@/lib/helpers/parseErrorMessage";
import { providerRequests } from "@/api/(requests)/provider";
import { sharedRequests } from "@/api/(requests)/shared";

import { getQueryParams } from "../../../utils/filters";
import { showAlert } from "../../../redux/actions/alerts";
import store from "../../../redux/store";
import { uploadInsuranceImageFile, UserFileTypes } from "../../../utils/fileUtil";

export const fetchPatientList = ({ context }) => {
  return providerRequests.fetch_patient_list({ context });
};

export const uploadAnonymousInsuranceImage = (imgData, attr, cb) => {
  const { file, fileName } = imgData;

  try {
    uploadInsuranceImageFile(file, fileName, null, UserFileTypes.ANONYMOUS_INSURANCE_IMAGE)
      .then((base64Img) => {
        cb(attr, { preview: base64Img, url: fileName });
      })
      .catch((err) => {
        showAlert(parseErrorMessage(err), store.dispatch);
        console.log(err);
      });
  } catch (err) {
    showAlert(parseErrorMessage(err), store.dispatch);
    console.log(err);
  }
};

//deprecated use fileUtil
export const getFile = (patientId, key) => {
  let urlParams = { patientId };
  let data = { key: key };

  sharedRequests
    .fetch_patient_file({ data, urlParams })
    .then((response) => {
      let url = response.message;

      if (url) {
        window.open(url);
      }
    })
    .catch((err) => {
      let errMsg =
        (err.response && err.response.data.results.message) || "Some unexpected error occured";

      console.log(errMsg);
    });
};

export const getScreeningAnswers = async (type, props, state, cb) => {
  try {
    let urlParams = {
      day: getQueryParams("day", props.location.search.trim()),
      patientId: state.patientId,
      type: type,
    };
    let response = await sharedRequests.fetch_patient_phq9_gad7({ urlParams });

    if (response && response.result) {
      cb(response.result);
    }
  } catch (err) {
    console.log(err);
  }
};

/**
 * Transforms question list received from api to the form
 * expected by submit api.
 *
 * @param {Array.<{id: number, question: string}>} qArray Array of question objects
 *
 * @param answers response from previously submitted screening that we wish to display
 */
export const transformScreeningQuestionsArray = (qArray, answers) => {
  let transformedQuestionsArray;

  if (!answers) {
    transformedQuestionsArray = qArray.map((q) => {
      return { answer: null, question: q.question, question_id: q.id };
    });
  } else {
    transformedQuestionsArray = qArray.map((q, i) => {
      return { answer: parseInt(answers[i].rating), question: q.question, question_id: q.id };
    });
  }

  return transformedQuestionsArray;
};
